"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/dashboard/v1/legacy_portal_common.proto (package spwn.dashboard.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyPortalIssuedTicketsSummary = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * ダッシュボードに表示するチケットの情報
 *
 * @generated from message spwn.dashboard.v1.LegacyPortalIssuedTicketsSummary
 */
class LegacyPortalIssuedTicketsSummary extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string ticket_id = 1;
         */
        this.ticketId = "";
        /**
         * @generated from field: string ticket_name = 2;
         */
        this.ticketName = "";
        /**
         * @generated from field: int32 purchased_count = 3;
         */
        this.purchasedCount = 0;
        /**
         * @generated from field: int32 checked_in_count = 4;
         */
        this.checkedInCount = 0;
        /**
         * @generated from field: double checked_in_rate = 5;
         */
        this.checkedInRate = 0;
        /**
         * @generated from field: int32 redeemable_count = 6;
         */
        this.redeemableCount = 0;
        /**
         * @generated from field: int32 redeemed_count = 7;
         */
        this.redeemedCount = 0;
        /**
         * @generated from field: double redeemed_rate = 8;
         */
        this.redeemedRate = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalIssuedTicketsSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalIssuedTicketsSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalIssuedTicketsSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalIssuedTicketsSummary, a, b);
    }
}
exports.LegacyPortalIssuedTicketsSummary = LegacyPortalIssuedTicketsSummary;
LegacyPortalIssuedTicketsSummary.runtime = protobuf_1.proto3;
LegacyPortalIssuedTicketsSummary.typeName = "spwn.dashboard.v1.LegacyPortalIssuedTicketsSummary";
LegacyPortalIssuedTicketsSummary.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ticket_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "purchased_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "checked_in_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "checked_in_rate", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "redeemable_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "redeemed_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "redeemed_rate", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
]);
//# sourceMappingURL=legacy_portal_common_pb.js.map